class DoseOutcomeMetric extends HTMLElement {
  connectedCallback() {
    if (this.observer) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.classList.add('is-visible');
          this.observer.unobserve(this);
        });
      },
      { threshold: 0.4 }
    );

    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }
}

if (!customElements.get('dose-outcome-metric')) {
  customElements.define('dose-outcome-metric', DoseOutcomeMetric);
}
